function getScrollBarWidth() {
	var c = document.createElement("p");
	c.style.width = "100%";
	c.style.height = "200px";
	var d = document.createElement("div");
	d.style.position = "absolute";
	d.style.top = "0px";
	d.style.left = "0px";
	d.style.visibility = "hidden";
	d.style.width = "200px";
	d.style.height = "150px";
	d.style.overflow = "hidden";
	d.appendChild(c);
	document.body.appendChild(d);
	var b = c.offsetWidth;
	d.style.overflow = "scroll";
	var a = c.offsetWidth;
	if (b == a) {
		a = d.clientWidth
	}
	document.body.removeChild(d);
	return (b - a)
}
var app = {
    common: function() {
        var scrollTop = $(window).scrollTop();
        if(scrollTop > 0) {
            $('#mainHeader').addClass('mainHeader--sticky');
        } else {
            $('#mainHeader').removeClass('mainHeader--sticky');
        }
        
        // Scroll Event
        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > 0) {
                $('#mainHeader').addClass('mainHeader--sticky');
            } else {
                $('#mainHeader').removeClass('mainHeader--sticky');
            }
        });

        // Sidemenu
        $('#showMenu').click(function(e) {
			e.preventDefault();
            $(this).toggleClass('active');
            $('#mainMenu').slideToggle();
            $(this).find('img').attr('src', function(index, attr) {
				var newAttr = attr.split('/');
				var curImg = newAttr[newAttr.length - 1].split('.')[0];
				var path = newAttr.slice(0, newAttr.length - 1).join('/');

				if(curImg == 'menu') {
					// $(this).closest('.primaryMenu').find('#toggleMenu').slideDown(400);
					return path + '/close.svg'
				} else {
					// $(this).closest('.primaryMenu').find('#toggleMenu').slideUp(300);
					return path + '/menu.svg'
				}
			});
        });

        // Mobile dropdown toggle
		$('.dropdown-handle').click(function() {
			var siblings = $(this).parents('li').siblings();
			siblings.find('.dropdown-custom').slideUp();
			siblings.find('.dropdown-handle').removeClass('active');
			$(this).parents('li').find('.dropdown-custom').slideToggle();
            $(this).parent().toggleClass('active');
		});
    },

    homePage: function () {
        $('.workSubSlider').slick({
            infinite: true,
            arrows: true,
            dots: true,
            speed: 500,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplaySpeed: 2000,
        });
        $('#workSlider').slick({
            infinite: true,
            arrows: false,
            dots: false,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplaySpeed: 2000,
        });

        $('#serviceSlider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('#projectsSlider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplaySpeed: 2000,
        });

        $('#testimonialsSlider').slick({
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplaySpeed: 2000,
            responsive: [
                // {
                //     breakpoint: 993,
                //     settings: {
                //         slidesToShow: 3
                //     }
                // },
                // {
                //     breakpoint: 768,
                //     settings: {
                //         slidesToShow: 2
                //     }
                // },
                // {
                //     breakpoint: 481,
                //     settings: {
                //         slidesToShow: 1
                //     }
                // }
            ]
        });
    },

    init: function () {
        this.common();
        this.homePage();
    }
};

$(document).ready(function() {
    app.init();
    if(window.location.hash) {
        var type = '#'+ window.location.hash.substr(1);
        var type2 = window.location.hash.substr(1);
        $('.tabsBlock .tab').removeClass('active');
        $('.tabsBlock .serviceTab').removeClass('show');
        $('.tabsBlock .tab[data-tab = '+type+']').addClass('active');
        $('.tabsBlock .serviceTab[id = '+type2+']').addClass('show');
    }
    
    $(".tabsBlock .tab").click(function(){
        $(".tabsBlock .tab").removeClass("active");
        $(this).addClass("active");
        var tabId = $(this).attr("data-tab");
        $(".tabsBlock .serviceTab").removeClass("show");
        $(tabId).addClass("show");
    });

    // top slide  start
    $(".linkToTop").click(function(){
        $("html, body").animate({scrollTop:0},"slow");
        return false;
    });
    // top slide end
    function scrollToElement (obj) {
        $('html, body').animate({
          scrollTop: obj.offset().top
        }, 1000);    
      };
      
      $('.contactLink a').click(function () {
        scrollToElement($(this));
      });

    var pathname = window.location.pathname;
    pathname = pathname.split('/').pop().split('#').pop().split('?').pop();
    $("#mainMenu").find('a').each(function () {
        if($(this).attr("href") === pathname){
            $("#mainMenu li").removeClass("active");
            $(this).closest('li').addClass("active");
        }
    });


    $(".skillSection__content").mCustomScrollbar({
        axis:"x"
    });

    $('.count').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    }); 
});

if($(".animated")) {
    $(".animated").appear(function () {
      var b = $(this);
      var c = b.data("animation");
      if (!b.hasClass("visible")) {
        var a = b.data("animation-delay");
        if (a) {
          setTimeout(function () {
            b.addClass(c + " visible")
          }, a)
        } else {
          b.addClass(c + " visible")
        }
      }
    })
}


$("#tryForFreeForm").validate({
    rules: {
        name: "required",
        mobile: {
            required: true,
            number: true
        },
        email: {
            required: true,
            email: true
        },
        services: "required"
    },
    messages: {
        name: "Please enter your name",
        mobile: {
            required: "Please enter your mobile",
            number: "Please enter valid mobile"
        },
        email: {
            required: "Please enter a valid email address",
            email: "Please enter a valid email address"
        },
        email: "Please enter a valid email address",
        services: "Please select services"
    }
});


$("#contactPageForm").validate({
    rules: {
        name: "required",
        mobile: {
            required: true,
            number: true
        },
        email: {
            required: true,
            email: true
        },
        subject: "required"
    },
    messages: {
        name: "Please enter your name",
        mobile: {
            required: "Please enter your mobile",
            number: "Please enter valid mobile"
        },
        email: {
            required: "Please enter a valid email address",
            email: "Please enter a valid email address"
        },
        email: "Please enter a valid email address",
        subject: "Please enter subject"
    }
});

$('.modal').on('shown.bs.modal', function () {
    $('.mainHeader').css('right', getScrollBarWidth());
})
$('.modal').on('hide.bs.modal', function () {
    $('.mainHeader').css('right', 0);
})